import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import NotFound from '../../container/pages/404';
import useRole from '../../hooks/useRole';

const EstatesList = lazy(() => import('../../container/statesManagement/EstatesList'));
const CreateEstate = lazy(() => import('../../container/statesManagement/CreateEstate'));
const DetailsEstate = lazy(() => import('../../container/statesManagement/DetailsEstate'));
const EditEstate = lazy(() => import('../../container/statesManagement/EditEstate'));

function InmueblesManagement() {
  const { path } = useRouteMatch();
  const role = useRole();
  const isAdmin = role === 'administrador';

  return (
    <Switch>
      <Route exact path={path} component={EstatesList} />
      <Route path={`${path}/crear`} render={() => (isAdmin ? <CreateEstate /> : <NotFound />)} />
      <Route path={`${path}/editar/:estateId`} render={() => (isAdmin ? <EditEstate /> : <NotFound />)} />
      <Route path={`${path}/detalles/:estateId`} component={DetailsEstate} />
    </Switch>
  );
}

export default InmueblesManagement;
